export function atSetVehicleType(state, payload) {
  state.type = payload;
}

export function atSetLicencePlateAndEmail(state, payload) {
  state.licencePlate = payload.licencePlate;
  state.email = payload.email;
}

export function atSetDuration(state, payload) {
  state.duration = payload;
}

export function flush(state) {
  state.type = null;
  state.licencePlate = null;
  state.email = '';
  state.duration = 1;
}
